module.exports = " <div v-if=projects> <div class=Modal__header> <h3>Supprimer les parcours ?</h3> </div> <div class=Modal__body> <p>Vous êtes sur le point de supprimer définitivement les parcours.</p> <p>Toutes les données relatives à ces parcours seront également supprimées.</p> </div> <div class=Modal__footer> <button class=Modal__buton-ok @click=cancel()> Annuler </button> <button class=Modal__buton-danger @click=confirm()> Supprimer </button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/modals/DeleteProjects.vue
// module id = 509
// module chunks = 1